module.exports = __webpack_public_path__ + "shipped.svg?c9d07597f9981b5f1459c41ac39a125f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shipped.svg
// module id = 89
// module chunks = 0